<template>
<div>
    <div class="columns is-centered has-background-dvodark">
      <div class="column is-10">
          <h2 class="has-text-left has-text-white is-size-1 mb-2">Login</h2>
            <div class="field">
                <div class="control">
                  <input class="input has-text-white" placeholder="Email Address" type="email" v-model="email">
                </div>
              </div>
              <div class="field">
                <div class="control">
                  <input class="input has-text-white" placeholder="Password" type="password" v-model="pass">
                </div>
              </div>
      </div>
    </div>
      <div class="columns is-centered has-background-dvodark">
      <div class="column is-10">
        <div class="field is-grouped">
            <b-button @click="signIn" class="button is-dvogreen" expanded :loading="isLoading">Login</b-button>
            <b-button tag="router-link"
                to="/passwordReset"
                type="is-dvogrey"
                expanded>
                Password Reset
            </b-button>
        </div>
        <p>

        </p>
      </div>
    </div>
    <div class="columns has-background-dvodark">
      <div class="column">
        <v-alert />
      </div>
    </div>
</div>

</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import router from "@/router";
import store from "@/store";

import Alert from "@/components/auth/Alert.vue";

Vue.component("v-alert", Alert);

export default {
  data() {
    return {
      email: "",
      pass: "",
      isLoading: false
    };
  },
  computed: {
    ...mapGetters("auth", ["hasAuthenticationStatus"])
  },
  methods: {
    async signIn() {
      this.isLoading = true
      await store.dispatch("auth/signIn", {
        username: this.email,
        password: this.pass
      });

      if (!this.hasAuthenticationStatus) {
        router.push("Home");
      }
      this.isLoading = false;
    }
  }
};
</script>

<style>
h2{
  font-family: "Anton", sans-serif;
}
</style>
